import { render, staticRenderFns } from "./AutoConfirmCountdown.vue?vue&type=template&id=2bedf104&lang=pug&"
import script from "./AutoConfirmCountdown.vue?vue&type=script&lang=js&"
export * from "./AutoConfirmCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports